import React from 'react';
import { Form } from '../types';
import { ValueValidation } from '@g17eco/types/universalTracker';
import { RadioInput } from '@g17eco/molecules/form/RadioInput';

interface Props {
  formData: Form;
  setValueValidation: (value: ValueValidation) => void;
  isAnswered: boolean;
}

export const TableTypeConfiguration = ({ formData, setValueValidation, isAnswered }: Props) => {
  // Determine current value: 'single' or 'multi'
  const isSingleRow = formData.valueValidation?.table?.validation?.maxRows === 1;
  const currentValue = isSingleRow ? 'single' : 'multi';

  const handleRowOptionChange = ({ value }: { value: any }) => {
    const tableConfig = formData.valueValidation?.table || { columns: [] };
    const newValidation = value === 'single' ? { maxRows: 1 } : undefined;

    setValueValidation({
      ...formData.valueValidation,
      table: {
        ...tableConfig,
        validation: newValidation
      }
    });
  };

  const options = [
    { code: 'single', name: 'Single-row' },
    { code: 'multi', name: 'Multi-row' }
  ];

  return (
    <div className='mt-3'>
      <RadioInput
        groupCode='rowRequest'
        value={currentValue}
        disabled={isAnswered}
        onChange={handleRowOptionChange}
        options={options}
        formGroupClassName='form-check-inline'
      />
    </div>
  );
};
